import styled from 'styled-components';

export const StyledSwitcherWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'flex-start',

  '& > button:first-child': {
    borderRadius: '4px',

    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  '& > button:last-child': {
    borderRadius: '4px',

    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },

  '& > button: nth-of-type(even)': {
    borderLeft: 0,
  },
}));

export const StyledSwitcher = styled.button<{ $active?: boolean }>(
  ({ theme, $active = false }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: $active ? '#E8E8E8' : '#FFFFFF',
    border: '1px solid #C4C4C4',
    minWidth: '97px',

    cursor: 'pointer',
    padding: '7px 12px',
  }),
);
